module.exports = __webpack_public_path__ + "media/banner/banner-5-ad38131c.jpg";